import React from "react";
import Header from "../component/menu/Header";
import { constants } from "../constant/constants";
import SideMenu from "../component/menu/SideMenu";
import FormHeaderComponent from "../component/FormHeaderComponent";
import { notification } from "antd";
import RestaurantCreateComponent from "../component/restaurants/RestaurantCreateComponent";
import CustomLoader from "../component/menu/CustomLoader";

function RestaurantCreate() {
  const [api, contextHolder] = notification.useNotification();
  return (
    <div className="flex flex-col bg-[#e5e7eb]">
      {contextHolder}
      <CustomLoader />
      <Header title={""} menu={constants.SUPER_MENU.RESTAURANT} currentMenuKey={'T_51_S_51'}/>
      <div className="flex flex-row bg-prewhite">
        <SideMenu
          title={`McDonalds Food Chain`}
          menu={constants.SUPER_MENU.RESTAURANT}
        />
        <div className="flex flex-row p-[24px] w-full mt-[80px] ml-[80px]">
          <div className="flex flex-col w-full">
             <FormHeaderComponent title={'Restaurant Create'} listRoute="/restaurants"/>
            <div className="flex flex-col">
              <RestaurantCreateComponent />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RestaurantCreate;
